import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { PageGrid } from '../../../../utils/page-grid';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { AccountService } from '../../../../services/account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PortalProductsService } from '../../../../services/portal-products.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from '../../../../services/http.service';

import * as moment from 'moment';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-download-reports',
  templateUrl: './download-reports.component.html',
  styleUrls: ['./download-report.component.scss'],
})
export class DownloadReportsComponent implements OnInit, OnDestroy {
  downloadingReport = false;
  paramInvestorCode = null;
  investmentCodeTemp = null;
  unSubscribe: Subscription;
  currentDate = new Date();

  portfolioDataForm = new FormGroup({
    date: new FormControl(new Date(), Validators.required),
  });
  confirmationNoteForm = new FormGroup({
    fromDate: new FormControl(new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1), Validators.required),
    toDate: new FormControl(new Date(), Validators.required),
  });
  ledgerStatementForm = new FormGroup({
    fromDate: new FormControl(new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1), Validators.required),
    toDate: new FormControl(new Date(), Validators.required),
  });
  taxCertificateForm = new FormGroup({
    fromDate: new FormControl(new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1), Validators.required),
    toDate: new FormControl(new Date(), Validators.required),
  });

  selectType = '';
  invalidDateRange = '';
  maxDate = new Date();

  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private httpService: HttpService,
    private cdRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute
  ) {
    this.unSubscribe = this.activatedRoute.parent.params.subscribe(async (params) => {
      this.paramInvestorCode = params['investorCode'];
    });
  }

  ngOnInit() {
    this.confirmationNoteForm.get('fromDate').valueChanges.subscribe(() => {
      if (this.confirmationNoteForm.get('toDate').value) {
        this.confirmationNoteForm.get('toDate').setValue(null);
      }
    });

    this.ledgerStatementForm.get('fromDate').valueChanges.subscribe(() => {
      if (this.ledgerStatementForm.get('toDate').value) {
        this.ledgerStatementForm.get('toDate').setValue(null);
      }
    });

    this.taxCertificateForm.get('fromDate').valueChanges.subscribe(() => {
      if (this.taxCertificateForm.get('toDate').value) {
        this.taxCertificateForm.get('toDate').setValue(null);
      }
    });
  }

  async submitFormData(form, type) {
    this.selectType = type;
    if (form.invalid) {
      return;
    }

    try {
      if (type === 'portfolio') {
        let url = `/portfolio-data/customer-portfolio-data-report?investorCode=${this.paramInvestorCode}&date=${moment(
          this.portfolioDataForm.value.date
        ).format('YYYY-MM-DD')}`;
        await this.downloadReport(url, 'Customer Portfolio Data Report', moment(this.portfolioDataForm.value.date).format('YYYY-MM-DD'));
      } else if (type === 'confirmation') {
        if (new Date(form.value.fromDate) > new Date(form.value.toDate)) {
          this.invalidDateRange = 'Invalid Date Range';
          setTimeout(() => {
            this.invalidDateRange = '';
            this.selectType = '';
          }, 2000);
          return;
        }
        let url = `/portfolio-data/customer-confirmation-note?investorCode=${this.paramInvestorCode}&fromDate=${moment(
          this.confirmationNoteForm.value.fromDate
        ).format('YYYY-MM-DD')}&toDate=${moment(this.confirmationNoteForm.value.toDate).format('YYYY-MM-DD')}`;
        await this.downloadReport(
          url,
          'Customer Confirmation Note',
          moment(this.confirmationNoteForm.value.fromDate).format('YYYY-MM-DD') +
            '_' +
            moment(this.confirmationNoteForm.value.toDate).format('YYYY-MM-DD')
        );
      } else if (type === 'ledger') {
        if (new Date(form.value.fromDate) > new Date(form.value.toDate)) {
          this.invalidDateRange = 'Invalid Date Range';
          setTimeout(() => {
            this.invalidDateRange = '';
            this.selectType = '';
          }, 2000);
          return;
        }
        let url = `/portfolio-data/customer-ledger-statement?investorCode=${this.paramInvestorCode}&fromDate=${moment(
          this.ledgerStatementForm.value.fromDate
        ).format('YYYY-MM-DD')}&toDate=${moment(this.ledgerStatementForm.value.toDate).format('YYYY-MM-DD')}`;
        await this.downloadReport(
          url,
          'Customer Ledger Statement',
          moment(this.ledgerStatementForm.value.fromDate).format('YYYY-MM-DD') +
            '_' +
            moment(this.ledgerStatementForm.value.toDate).format('YYYY-MM-DD')
        );
      } else {
        if (new Date(form.value.fromDate) > new Date(form.value.toDate)) {
          this.invalidDateRange = 'Invalid Date Range';
          setTimeout(() => {
            this.invalidDateRange = '';
            this.selectType = '';
          }, 2000);
          return;
        }
        let url = `/portfolio-data/customer-tax-certificate?investorCode=${this.paramInvestorCode}&fromDate=${moment(
          this.taxCertificateForm.value.fromDate
        ).format('YYYY-MM-DD')}&toDate=${moment(this.taxCertificateForm.value.toDate).format('YYYY-MM-DD')}`;
        await this.downloadReport(
          url,
          'Customer Tax Certificate',
          moment(this.taxCertificateForm.value.fromDate).format('YYYY-MM-DD') +
            '_' +
            moment(this.taxCertificateForm.value.toDate).format('YYYY-MM-DD')
        );
      }
    } catch (e) {
      console.log(e);
      this.handleErrorBlob(e);
    }
  }

  async downloadReport(downloadUrl: string, fileName, date) {
    this.downloadingReport = true;
    this.cdRef.detectChanges();
    // let downloadURL = this.httpService.baseApiUrl + this.httpService.baseApiPath + '/live-market-data/download-stock-tracker-data-pdf';
    try {
      let data = await this.get(downloadUrl);
      this.downloadFile(data, fileName + '-' + date + '.pdf');
      this.downloadingReport = false;
      this.cdRef.detectChanges();
    } catch (e) {
      console.log(e.error);
      this.downloadingReport = false;
      this.handleErrorBlob(e);
    }
  }

  /**
   * Handles error responses that may be Blob (e.g., PDF or JSON error from backend)
   */
  private async handleErrorBlob(e: any) {
    let errorMsg = '';
    if (e?.error instanceof Blob) {
      try {
        // Try to read as text (could be JSON or plain text)
        const text = await e.error.text();
        try {
          const json = JSON.parse(text);
          errorMsg = json.message || text;
        } catch {
          errorMsg = text;
        }
      } catch {
        errorMsg = 'An unknown error occurred.';
      }
    } else {
      errorMsg = e?.error?.message || e?.message || 'An unknown error occurred.';
    }
    this.errorMessage = errorMsg;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.errorMessage = '';
      this.cdRef.detectChanges();
    }, 3000);
  }

  downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 1);
  };

  get(url: string, data?: any) {
    const token = localStorage['atk'];
    let formattedUrl = this.httpService.baseApiUrl + this.httpService.baseApiPath + url;
    let headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token);

    return this.http.get(formattedUrl, { headers, responseType: 'blob' }).toPromise();
  }

  ngOnDestroy() {
    this.unSubscribe.unsubscribe();
  }
}
